module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9542.4d3819dc.jpg";